import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

function NotFound() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "65vh",
      }}
    >
      <Typography
        variant="h1"
        color="#636363"
        textAlign="center"
        fontSize={48}
        marginBottom={5}
      >
        404
      </Typography>
      <Typography
        variant="h1"
        color="#636363"
        textAlign="center"
        marginBottom={5}
      >
        {t("Notfound.notfound")}
      </Typography>
    </Box>
  );
}

export default NotFound;
